import { FC } from 'react'

import { Text, GreyGrey60, Primary12Regular } from '@sequencehq/core-components'
import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { format, isAfter, parseDateFromApi } from '@sequencehq/utils/dates'

const SHOW_WARNING_WHEN_CREATED_BEFORE = parseDateFromApi('2026-01-09') ?? ''

/**
 * Show a warning for quotes created before analytics tracking was enabled.
 * Using the createdAt value in the conditional as publishedAt can change if a quote is re-published - it may
 * still have incomplete view data before the republish was done.
 */
export const MissingDataWarning: FC = () => {
  const ctx = useCubeContext()

  const createdAt = ctx.queries.rawData.data.common.createdAt

  if (createdAt && isAfter(createdAt, SHOW_WARNING_WHEN_CREATED_BEFORE)) {
    return null
  }

  return (
    <Text
      {...Primary12Regular}
      color={GreyGrey60}
      data-testid="quoteAnalytics.missingDataWarning"
    >
      Data may be incomplete for quotes published before{' '}
      {format(SHOW_WARNING_WHEN_CREATED_BEFORE, 'd MMM yyyy')}
    </Text>
  )
}
